import { render, staticRenderFns } from "./DeleteAddress.vue?vue&type=template&id=648a7f28"
import script from "./DeleteAddress.vue?vue&type=script&lang=js"
export * from "./DeleteAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports